<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="view mtb80">
                    <div class="form_box">
                        <h2>문의하기 <a href="javascript:void(0)" @click="goMyInquiry">나의문의 내역</a></h2>
                        <div class="input_wrap">       
                            <input type="hidden" name="userid" id="userid" v-model="form.userid">
                            <input type="hidden" name="username" id="username" v-model="form.username">
                            <div class="inp_box">
                                <label for="name">문의유형</label>
                                <select name="type" id="type" v-model="form.type">
                                    <option value="1">회원가입 및 로그인</option>
                                    <option value="2">BIM-라이브러리 마켓</option>
                                    <option value="3">설계 및 시뮬레이션</option>                                    
                                    <option value="5">유지관리 서비스</option>
                    <option value="8">ZEB 제조사</option>
                                    <option value="6">온라인 세미나/교육</option>
                                    <option value="7">홍보업체등록</option>
                    <option value="4">포인트 충전 및 환불</option>
                                </select>
                            </div>
                            <div class="inp_box">
                                <label for="title">제목</label>
                                <input type="text" id="title" name="title" placeholder="제목을 입력해주세요." v-model="form.title">
                            </div>
                            <div class="inp_box">
                                <label for="name">성함</label>
                                <input type="text" id="name" name="name" placeholder="성함을 입력해주세요." v-model="form.name">
                            </div>
                            <div class="inp_box">
                                <label for="email">E-mail</label>
                                <input type="text" id="email" name="email" placeholder="E-mail을 입력해주세요." v-model="form.email">
                            </div>
                            <div class="inp_box">
                                <label for="content">문의 내용</label>
                                <textarea name="content" id="content" placeholder="문의 내용을 입력해 주세요." v-model="form.content"></textarea>
                            </div>
                            <!--div class="upload">
                                <div class="up_area"
                                     @dragover.prevent
                                    @drop.prevent="handleDrop"
                                    @click="openFile"
                                >
                                    <img src="@/assets/imgfile.svg" alt="">
                                    <span>이미지를 드래그해서 드롭해주세요.</span>
                                </div>
                            </div>
                            <input type="file" name="inquiryimg" id="inquiryimg" ref="inquiryimg" style="display:none;" accept="image/jpeg, image/png, image/jpg" @change="handleFileSelect"-->
                        </div>
                                                
                    </div>
                    <div class="btns">
                        <button class="buttn" type="button" @click="submitInquiry">문의등록</button>
                    </div>    
                    
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
import api from '@/api'
import TheHeader from '@/components/TheHeader.vue'   
import TheFooter from '@/components/TheFooter.vue'

export default {
    name: 'InquiryForm',
    components: { TheHeader, TheFooter },

    data() {
        return {
            preview: null,
        isLoggedIn: false,
            form: {
                userid: '',
                username: '',
                email: '',
                type: '1',
                title: '',
                name: '',
                content: '',
                img: null
            }
        }
    },

    mounted() {
        this.checkLogin()
    this.setTypeFromQuery()
    },

    methods: {
          goMyInquiry() {
            if (!this.isLoggedIn) {
                const ok = confirm(
                    "로그인이 필요한 서비스입니다.\n\n로그인 페이지로 이동합니다"
                )
 
                if (ok) {
                    const referer = this.$route.fullPath    
                    window.location.href =
                        `/login_form?referer=${encodeURIComponent(referer)}`
                }
                return
            }

            // 로그인 상태
            this.$router.push('/inquire_history')
        },
        async checkLogin() {
            try {
                const res = await api.get('/admin/user-info', { withCredentials: true })

                if (res.data.loggedIn) {
                    const user = res.data.user
                    this.isLoggedIn = true
                    this.form.userid = user.id
                    this.form.username = user.username
                    this.form.email = user.email
                    this.form.name = user.name
                }
            } catch (e) {
                console.log('비로그인 상태')
            }
        },

        /* 파일 선택 */
        openFile() {
            this.$refs.inquiryimg.click()
        },

        handleFileSelect(e) {
            const file = e.target.files[0]
            this.validateFile(file)
        },

        handleDrop(e) {
            const file = e.dataTransfer.files[0]
            this.validateFile(file)
        },

        validateFile(file) {
            if (!file) return

            const allowed = ['image/jpeg', 'image/png', 'image/jpg']
            if (!allowed.includes(file.type)) {
                alert('이미지 파일만 업로드 가능합니다.')
                return
            }

            this.form.img = file

            // input에 강제로 넣기
            const dt = new DataTransfer()
            dt.items.add(file)
            this.$refs.inquiryimg.files = dt.files

            this.preview = URL.createObjectURL(file)    
        },

    setTypeFromQuery() {
            const type = this.$route.query.type

            // 유효한 값인지 체크 (선택사항이지만 추천)
            const validTypes = ['1','2','3','4','5','6','7','8']

            if (type && validTypes.includes(type)) {
                this.form.type = type
            }
     },

        /* 문의 등록 */
        async submitInquiry() {
            if (!this.form.name) return alert('성함을 입력해주세요.')
            if (!this.form.email) return alert('이메일을 입력해주세요.')
            if (!this.form.title) return alert('제목을 입력해주세요.')
            if (!this.form.content) return alert('내용을 입력해주세요.')

            let formData = new FormData()
            for (let key in this.form) {
                if (this.form[key] !== null) {
                    formData.append(key, this.form[key])
                }
            }

            await api.get('/sanctum/csrf-cookie', { withCredentials: true })

            const res = await api.post('/admin/inquiry_store', formData, {
                withCredentials: true
            })

            if (res.data.success) {
                alert('문의가 접수되었습니다.')
                this.$router.push({
                    path: '/inquire_history',
                    query: { page: 1 }
                })
            }
        }
    }
}
</script>